export const sumBudgetNumbers = (values: Record<string, Record<string, unknown>>): number => {
    let total = 0;
    for (const section of Object.values(values ?? {})) {
        for (const [key, value] of Object.entries(section ?? {})) {
            if (!value) continue;

            if (/Phone/.test(key)) continue; // Ignores phone number fields
            if (typeof value === 'number') {
                total += value;
            } else if (typeof value[1] === 'number') {
                total += value[1];
            } else if (typeof value[0] === 'number') {
                total += value[0];
            }
        }
    }
    return total;
};
